const MsjHome = () => {
   return (
      <div className="section animated fadeIn" style={{ margin: '30px 0', padding: 0 }}>
         {/* TARJETA / BANNER DE LLAMADO A LA ACCIÓN (CTA) */}
         <div className="card-panel bg-latitud z-depth-2" style={{ borderRadius: '12px', backgroundColor: '#039be5', margin: '0 auto', maxWidth: '1400px' }}>
            <div className="row center white-text" style={{ margin: 0 }}>
               <div className="col s12">
                  <h6 style={{ fontWeight: '700', lineHeight: '1.4', margin: 0, letterSpacing: '0.5px' }}>
                     Más de 3.000 empresas ya son parte de Latitud Sur. ¡Te invitamos a sumarte!
                  </h6>
               </div>
            </div>
         </div>
      </div>
   );
}

export default MsjHome